const Decimal = require('decimal.js-light');

const toDecimalPlaces = (dp, n) => Number(new Decimal(n).toDecimalPlaces(dp));

export default toDecimalPlaces;
